export default "__VITE_ASSET__Cgm6P6Bm__"